/*
  This hook is used to handle navigation to the in-store FAQ section.
  It checks the current page name and either closes the Modal and updates the URL hash to scroll directly
  to the FAQ section if the user is already on the in-store page, or redirects the user to the in-store page
  with the FAQ section hash if user is on a different page.
*/

import { useSelector } from 'react-redux';
import { selectPageName } from 'core/selectors/app';
import { useNavigate } from 'react-router-dom';
import { FAQ_ID } from 'core/modules/Instore2/utils/constants';
import { useModal } from 'core/modules/Modal/ModalProvider';

export const useScrollToFaq = () => {
  const navigate = useNavigate();
  const pageName = useSelector(selectPageName);
  const { closeModal } = useModal();

  const onFaqClick = () => {
    const URL = `/instore#${FAQ_ID}`;

    const updateHashToScroll = () => {
      closeModal();
      setTimeout(() => { navigate(URL); }, 100);
    };

    pageName === 'is' ? updateHashToScroll() : window.location.assign(URL);
  };

  return { onFaqClick };
};
